// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"press-via-tt_wrapper__OpB11"};